export default __webpack_public_path__ + "static/media/I_Forms.cb732c19.png";